module.exports = __webpack_public_path__ + "static/children-inhabit-4c1334aa9a0183b9aeab31cf4e96b84f.png";